import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      header: {
        flex: '0 0 auto',
        overflow: 'hidden',
        position: 'relative',
      },

      subtitle: {
        ...tokens.fontBodyS,
        color: tokens.fontColorDefault,
        marginBlockEnd: 0,
        marginBlockStart: tokens.spacingGap100,
      },
    },
  } as const
}
